import DataTableGrid from '@bumble/app/components/DataTableGrid';
import { Loading } from '@bumble/app/components/Loading';
import PageContent from '@bumble/app/components/PageContent';
import PageHeader from '@bumble/app/components/PageHeader';
import { useApi } from '@bumble/app/hooks/use-api';
import { Card, CardContent } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useQuery } from '@tanstack/react-query';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import _ from 'lodash';

const columns: GridColDef[] = [
  {
    field: 'created_at',
    headerName: 'Time',
    minWidth: 200,
    disableColumnMenu: true,
    valueGetter: (params) => {
      if (params.value === null) return '';
      return DateTime.fromISO(params.value).toLocaleString(DateTime.DATETIME_SHORT);
    },
  },
  {
    field: 'username',
    headerName: 'Username',
    width: 200,
    disableColumnMenu: true,
  },
  // Command
  {
    field: 'url_path',
    headerName: 'Command',
    flex: 1,
    minWidth: 150,
    disableColumnMenu: true,
  },
  // Body
  {
    field: 'request_body',
    headerName: 'Body',
    flex: 1,
    minWidth: 200,
    disableColumnMenu: true,
  },
  // Params
  {
    field: 'query_parameters',
    headerName: 'Params',
    flex: 1,
    minWidth: 200,
    disableColumnMenu: true,
  },
  { field: 'account_id' },
  { field: 'iam_user_id' },
];

const columnVisible = {
  created_at: true,
  account_id: false,
  username: true,
  iam_user_id: false,
  url_path: true,
  query_parameters: true,
  request_body: true
};

export const Histories = () => {
  const api = useApi();

  const [logs, setLogs] = useState<any[]>([]);

  const { isLoading, data, refetch } = useQuery(
    ['apiLogs'],
    api.getApiLogApiV1GetApiLogGet.bind(null, {}),
    { enabled: true },
  );

  const handleDataRefetch = () => {
    refetch();
    toast.success('Refreshed View Changes.');
  };

  useEffect(() => {
    if (data?.data && data.data.length) {
      let sortedData = _.orderBy(data.data, ['created_at'], ['desc']);
      setLogs(sortedData.map((item, idx) => ({
        ...item,
        username: item.iam_user_username ? item.iam_user_username : item.account_username,
        id: idx,
        url_path: item.url_path?.replace('/api/v1', '')
      })));
    }
  }, [data]);

  return (
    <PageContent>
      <PageHeader
        pageName="View Changes"
        count={logs?.length || 0}
      />
      {isLoading ? (
        <Loading />
      ) : (
        <Card elevation={0}>
          <CardContent>
            <DataTableGrid
              rows={logs}
              columns={columns}
              columnVisibilityModel={columnVisible}
              refreshData={handleDataRefetch}
              pagination={true}
            />
          </CardContent>
        </Card>
      )}
    </PageContent>
  );
};
